
// eslint-disable-next-line @typescript-eslint/no-explicit-any

import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-favorites',
    templateUrl: './favorites.component.html',
    styleUrls: ['./favorites.component.scss'],
    standalone: false
})
export class FavoritesComponent {

}
